import React,{useState,useEffect} from "react";
import sliderInner from '../assets/images/sliderInner.jpg';
import leafIcn from '../assets/images/slider-shape-5.png';
import subThemes from "../helper/SubThemes_List";
import { useNavigate } from "react-router-dom";
import AdoptIcons1 from "../assets/images/icon/homeIcons/icon-1.png";
import AdoptIcons2 from "../assets/images/icon/homeIcons/icon-2.png";
import AdoptIcons3 from "../assets/images/icon/homeIcons/icon-3.png";
import AdoptIcons4 from "../assets/images/icon/homeIcons/icon-4.png";
import AdoptIcons5 from "../assets/images/icon/homeIcons/icon-5.png";
import AdoptIcons6 from "../assets/images/icon/homeIcons/icon-6.png";
import AdoptIcons7 from "../assets/images/icon/homeIcons/icon-7.png";
import AdoptIcons8 from "../assets/images/icon/homeIcons/icon-8.png";



function AdoptHealthylife() {
  const navigate = useNavigate();
  const [themeData, setThemeData] = useState(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

  const handleRoute = (data) => {
    localStorage.setItem('sub_themes', subThemes['Adopt Healthy Lifestyles'][data].value);
    navigate('/details');
  };

  const fetchDetails = async (data) => {
    try {
      const response = await fetch(`https://ecoclubs.education.gov.in/api/get-participants-details?theme=Adopt Healthy Lifestyles`); // Replace with your API URL
      const result = await response.json();
      setThemeData(result?.data); // Store fetched data in state
    } catch (error) {
      console.error("Error fetching theme data:", error);
    }

    
  };

  useEffect(()=>{
    fetchDetails();
  },[])

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
          <h2>Eco Clubs <span className="hdngBrkr">for Mission LiFE Themes</span></h2>
        </div>
      </section>

      <section className="sevenScopeSec reduceWasteSec">
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          <h2>Adopt <span className="hdngBrkr">Healthy Lifestyles</span> </h2>
          <button className="button green btn-login-signup loginBtnnewhm" style={{position:"absolute", right:"6%"}} onClick={()=>navigate(-1)} >Back</button>       
          <div className="sevenScopeBox">
            <ul className="themeGrid">
              {[
                { label: "Plantation Drive", icon: AdoptIcons1 },
                { label: "Nature Walk", icon: AdoptIcons2 },
                { label: "Awareness session", icon: AdoptIcons3 },
                { label: "Poster Making", icon: AdoptIcons4 },
                { label: "Debate", icon: AdoptIcons5 },
                { label: "Environment Day Celebration", icon: AdoptIcons6 },
                { label: "Competitions", icon: AdoptIcons7 },
                { label: "Flora QR codes", icon: AdoptIcons6 },
                { label: "Others", icon: AdoptIcons8 }
              ].map((theme, index) => (
                <li key={index} onClick={() => handleRoute(index)}>
                  <div className="themeBox">
                    <div className="themeBoxIcn"><img src={theme.icon} alt="" /></div>
                    <div className="themeBoxCnt">{theme.label}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className='stackHolderSec'>
        <img className="slider__shape-13 stackholdrLf" src={leafIcn} alt="" />
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          {/* <h2><span className="hdngBrkr">Stakeholders</span> Involved</h2> */}
          <div className="stackHldrCntDiv">
  <div className="row">
    <div className="col-6 stackLft">
      <h2 className="sbHdng">participation AT A GLANCE</h2>
      <div className="stackLftIn">
        <ul>
          <li>
             States/UTs <span>{36}</span>
          </li>
          <li>
            Districts <span>700</span>
          </li>
          <li>
            Total Schools <span>{themeData ? themeData.totalSchools : 0}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
        </div>
      </section>
    </>
  );
}

export default AdoptHealthylife;
